import { lazy } from 'react';

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Enum } from '@webapp/utils'
import messages from './messages'

export const ContractListPageStatuses = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DRAFT: 'draft',
  EXPIRED: 'expired',
  TERMINATED: 'terminated',
} as const
export type ContractListPageStatus = Enum<typeof ContractListPageStatuses>

export interface ContractListPageParams {
  status: ContractListPageStatus
}

const ContractListViewChunk = lazy(() =>
  import('../containers/ContractListView').then(({ ContractListView }) => ({
    default: ContractListView,
  }))
)

export const ContractListPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.contractListTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.contractListTitle),
        },
      ]}
    >
      <ContractListViewChunk />
    </Page>
  )
}
